/* JUSTYOL — drop product page. Before launch: countdown + save (handled by
   native-wishlist.js on the .wishlist-btn) + share. At launch: flip to buyable
   (add to cart → COD express). At launch the save/share bar is replaced by the
   buy bar (toBuyable hides the teaser actions to keep the footer uncrowded). */
(function () {
  'use strict';
  var root = document.querySelector('[data-jy-drop-product]');
  if (!root || root.__jyDP) return;
  root.__jyDP = true;

  var isAr = root.getAttribute('data-ar') === '1';
  var vid = root.getAttribute('data-vid');
  var title = root.getAttribute('data-title') || '';
  function t(fr, ar) { return isAr ? ar : fr; }

  var cd = root.querySelector('[data-jydp-cd]');
  var teaser = root.querySelector('[data-jydp-teaser]');
  var teaserInfo = root.querySelector('[data-jydp-teaser-info]');
  var buy = root.querySelector('[data-jydp-buy]');
  var eyebrow = root.querySelector('[data-jydp-eyebrow]');
  var addBtn = root.querySelector('[data-jydp-add]');
  var shareBtn = root.querySelector('[data-jydp-share]');
  var toast = root.querySelector('[data-jydp-toast]');

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    setTimeout(function () { toast.hidden = true; }, 2600);
  }

  /* ---- gallery thumbs ---- */
  var stageImg = root.querySelector('.jydp__img');
  root.querySelectorAll('[data-jydp-thumb]').forEach(function (th) {
    th.addEventListener('click', function () {
      var img = th.querySelector('img');
      if (img && stageImg) { stageImg.src = img.src.replace(/width=140/, 'width=900'); stageImg.srcset = ''; }
      root.querySelectorAll('[data-jydp-thumb]').forEach(function (o) { o.classList.remove('is-on'); });
      th.classList.add('is-on');
    });
  });

  /* ---- description clamp / "read more" ---- */
  var desc = root.querySelector('[data-jydp-desc]');
  var moreBtn = root.querySelector('[data-jydp-more]');
  if (desc && moreBtn) {
    // only offer expand when the content is actually taller than the clamp
    if (desc.scrollHeight > desc.clientHeight + 8) {
      moreBtn.hidden = false;
    } else {
      desc.classList.remove('is-clamped');
    }
    moreBtn.addEventListener('click', function () {
      desc.classList.remove('is-clamped');
      moreBtn.hidden = true;
    });
  }

  /* ---- launch state (Morocco +01:00) ---- */
  var raw = (root.getAttribute('data-drop-date') || '').trim();
  var dropMs = 0;
  if (raw) {
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw = raw.replace(' ', 'T') + '+01:00';
    var p = Date.parse(raw);
    if (!isNaN(p)) dropMs = p;
  }
  var launched = !dropMs || Date.now() >= dropMs;

  var cells = {
    d: root.querySelector('[data-cd="d"]'), h: root.querySelector('[data-cd="h"]'),
    m: root.querySelector('[data-cd="m"]'), s: root.querySelector('[data-cd="s"]')
  };
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function toBuyable() {
    launched = true;
    if (cd) cd.hidden = true;
    if (teaser) teaser.hidden = true; // save/share give way to the buy bar
    if (teaserInfo) teaserInfo.hidden = true; // "how it works" is pre-launch only
    if (buy) buy.hidden = false;
    if (eyebrow) eyebrow.textContent = t('🔥 En vente — quantité limitée', '🔥 محلول دابا · كمية محدودة');
  }

  var timer = null;
  function tick() {
    if (!dropMs || Date.now() >= dropMs) { toBuyable(); if (timer) { clearInterval(timer); timer = null; } return; }
    var s = Math.max(0, Math.floor((dropMs - Date.now()) / 1000));
    if (cd && s < 3600) cd.classList.add('is-soon'); // urgency pulse in the last hour
    if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
    if (cells.h) cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
    if (cells.m) cells.m.textContent = pad(Math.floor((s % 3600) / 60));
    if (cells.s) cells.s.textContent = pad(s % 60);
  }

  if (launched) {
    toBuyable();
  } else {
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---- share ---- */
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = location.href;
      if (navigator.share) {
        navigator.share({ title: title, text: t('Regarde cette offre sur Justyol 👀', 'شوف هاد العرض فجاستيول 👀'), url: url })
          .catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showToast(t('Lien copié ✓', 'تنسخ اللينك ✓'));
        }, function () {});
      } else {
        showToast(url);
      }
    });
  }

  /* ---- notify CTA in the sticky bar → jump to the WhatsApp field ---- */
  var notifyCta = root.querySelector('[data-jydp-notify-cta]');
  if (notifyCta) {
    notifyCta.addEventListener('click', function () {
      var n = root.querySelector('[data-jydp-notify]');
      if (!n) return;
      n.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var pi = n.querySelector('[data-jydp-phone]');
      if (pi) setTimeout(function () { pi.focus(); }, 420);
    });
  }

  /* ---- buy (after launch) → cart + COD express ---- */
  function openExpress() {
    var trg = document.createElement('button');
    trg.setAttribute('data-jy-cta', 'express');
    trg.style.display = 'none';
    document.body.appendChild(trg);
    trg.click();
    setTimeout(function () { trg.remove(); }, 0);
  }
  if (addBtn) {
    var added = false;
    addBtn.addEventListener('click', function () {
      if (!launched) return;
      /* already in the cart (shopper closed the popup and came back) → just
         re-open express, never disable the button dead or add a duplicate line */
      if (added) { openExpress(); return; }
      addBtn.disabled = true; addBtn.classList.add('is-loading');
      var routes = (window.FoxTheme && FoxTheme.routes) || {};
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false; // always re-enable so the CTA never dies
          if (!res.ok) {
            showToast((res.j && res.j.description) || t('Rupture de stock', 'سالى الستوك'));
            return;
          }
          added = true;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          openExpress();
        })
        .catch(function () {
          addBtn.disabled = false; addBtn.classList.remove('is-loading');
          showToast(t('Erreur réseau, réessayez', 'مشكل فالشبكة، عاود'));
        });
    });
  }

  /* ---- notify me (WhatsApp waitlist → worker /drop/register) ---- */
  var notify = root.querySelector('[data-jydp-notify]');
  if (notify) {
    if (launched) {
      notify.style.display = 'none';
    } else {
      var nForm = notify.querySelector('[data-jydp-notify-form]');
      var nInp = notify.querySelector('[data-jydp-phone]');
      var nBtn = notify.querySelector('[data-jydp-notify-send]');
      var nKey = notify.getAttribute('data-drop-key') || '';
      var notifyDone = function () {
        if (nForm) nForm.innerHTML = '<b style="color:#1a7f37;font-weight:800">' +
          t('✅ Enregistré — on te prévient sur WhatsApp', '✅ سجّلناك — غادي ننبّهوك ف واتساب منين يتحل') + '</b>';
      };
      try { if (localStorage.getItem('jy_drop_notify_' + nKey)) notifyDone(); } catch (e) {}
      if (nBtn) nBtn.addEventListener('click', function () {
        var v = ((nInp && nInp.value) || '').replace(/\D/g, '');
        if (v.length < 9) { if (nInp) nInp.focus(); showToast(t('Numéro invalide', 'الرقم ماشي صحيح')); return; }
        nBtn.disabled = true;
        fetch('https://justyol-cod.justyol.workers.dev/drop/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: v, product: nKey, lang: isAr ? 'ar' : 'fr' })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }); })
          .then(function (j) {
            if (j && j.ok) {
              try { localStorage.setItem('jy_drop_notify_' + nKey, '1'); } catch (e) {}
              notifyDone();
              if (root.__jyBumpWait) root.__jyBumpWait();
            } else {
              nBtn.disabled = false;
              showToast(t('Erreur, réessayez', 'وقع شي مشكل، عاود'));
            }
          })
          .catch(function () {
            nBtn.disabled = false;
            showToast(t('Erreur, réessayez', 'وقع شي مشكل، عاود'));
          });
      });
    }
  }

  /* ---- waitlist social proof: # of people registered (live from the worker) ---- */
  var wc = root.querySelector('[data-jydp-waitcount]');
  var wcEl = root.querySelector('[data-jydp-notify]');
  var wcKey = wcEl ? (wcEl.getAttribute('data-drop-key') || '') : '';
  if (wc && wcKey && !launched) {
    var WC_FLOOR = 20; // don't advertise weak numbers
    var renderWait = function (n) {
      if (!n || n < WC_FLOOR) { wc.hidden = true; return; }
      wc.innerHTML = '🔔 <b>' + n + '</b> ' + t('personnes attendent ce drop', 'كايتسناو هاد الدروب');
      wc.hidden = false;
    };
    root.__jyBumpWait = function () { window.__jyWaitN = (window.__jyWaitN || 0) + 1; renderWait(window.__jyWaitN); };
    fetch('https://justyol-cod.justyol.workers.dev/drop/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ count: true, product: wcKey })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) { if (j && j.ok) { window.__jyWaitN = j.count || 0; renderWait(window.__jyWaitN); } })
      .catch(function () {});
  }
})();
